import { call, put, takeLatest } from 'redux-saga/effects';
import {MANAGE_LEAVE_BALANCE, MANAGE_LEAVE_BALANCE_REQUEST} from '../actionType/type';
import { manageLeaveBalanceError, manageLeaveBalanceSuccess } from '../action/ManageLeaveBalanceAction';
import { postApiCall } from '../../service/PostApiCall';
import { MANAGE_LEAVE_BALANCE_API } from '../../service/apiUrl';

function* manageLeaveBalanceSaga (action) {
    try {
        const response = yield call(postApiCall,action?.params,action?.params?.access_token,MANAGE_LEAVE_BALANCE_API)
        yield put(manageLeaveBalanceSuccess(response));
        // action.onSuccess(response)
    } catch (error) {
        yield put(manageLeaveBalanceError(error));
    }
}
export function* watchManageLeaveBalanace () {
  yield takeLatest (MANAGE_LEAVE_BALANCE_REQUEST, manageLeaveBalanceSaga);
}
